module.exports = __webpack_public_path__ + "img/40_69_012_580.55448c79.jpg";